import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Server05 = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 9c0 4.0796-3.0537 7.446-7 7.9381v.2326A3.009 3.009 0 0 1 14.8293 19H21c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6.1707c-.4118 1.1652-1.5231 2-2.8293 2s-2.4175-.8348-2.8293-2H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h6.1707A3.009 3.009 0 0 1 11 17.1707v-.2326C7.0537 16.446 4 13.0796 4 9c0-4.4183 3.5817-8 8-8s8 3.5817 8 8M6.083 10h2.1796a11.71 11.71 0 0 0 1.4594 4.5524C7.8347 13.7773 6.4299 12.068 6.083 10m8.1975 4.5514A11.71 11.71 0 0 0 15.7392 10h2.1778c-.3467 2.0671-1.7505 3.7759-3.6365 4.5514M17.917 8c-.3468-2.0671-1.7505-3.7758-3.6365-4.5514A11.71 11.71 0 0 1 15.7392 8zM9.7219 3.4476C7.8347 4.2227 6.4299 5.932 6.0829 8h2.1797A11.71 11.71 0 0 1 9.722 3.4476m2.279.1404A9.71 9.71 0 0 1 13.7259 8h-3.45a9.71 9.71 0 0 1 1.725-4.412m0 10.8239a9.71 9.71 0 0 1-1.725-4.412h3.45a9.71 9.71 0 0 1-1.725 4.412",
      clipRule: "evenodd"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Server05;
//# sourceMappingURL=Server05.js.map